import React from "react";
import TemplateComponent from "../components/TemplateComponent";

const Template = () => {
  return (
    <div>
      <TemplateComponent />
    </div>
  );
};

export default Template;
